import * as React from 'react';
import { useEffect, useState } from 'react';
import AreaShell from '../../chrome/AreaShell';
import { TCard, TEmpty } from '../../components/table';
import usePhotoEngineerStats from '../../../PhotoEngineers/components/hooks/usePhotoEngineerStats';
import './admin-ops.css';

/*
 * New-org signups over rolling windows (the server counts orgs created in
 * the last 1 day / week / month / year). Read-only.
 */

const TILES: Array<{ key: 'day' | 'week' | 'month' | 'year'; label: string; sub: string }> = [
    { key: 'day', label: 'Last 24 hours', sub: 'new orgs' },
    { key: 'week', label: 'Last 7 days', sub: 'new orgs' },
    { key: 'month', label: 'Last month', sub: 'new orgs' },
    { key: 'year', label: 'Last year', sub: 'new orgs' },
];

/* The hook has no error state (a failed request leaves it loading), so give up waiting after a while. */
const GIVE_UP_MS = 20000;

const fmt = (v: unknown) => (typeof v === 'number' && Number.isFinite(v) ? v.toLocaleString() : '—');

export default function AdminStatsV3() {
    const { stats, isLoading } = usePhotoEngineerStats();
    const [slow, setSlow] = useState(false);

    useEffect(() => {
        if (!isLoading) return;
        const t = window.setTimeout(() => setSlow(true), GIVE_UP_MS);
        return () => window.clearTimeout(t);
    }, [isLoading]);

    const loading = isLoading && !slow;
    const failed = isLoading && slow;

    return (
        <AreaShell area="admin" tab="stats" sub="New organization signups across the platform">
            <div className="ao-page">
                {failed ? (
                    <TCard>
                        <TEmpty
                            message="Couldn’t load signup stats. Reload the page to try again."
                            actionLabel="Reload"
                            onAction={() => window.location.reload()}
                        />
                    </TCard>
                ) : (
                    <div className="ao-tiles" aria-busy={loading}>
                        {TILES.map((t) => (
                            <div className="tile" key={t.key}>
                                <p className="tl">{t.label}</p>
                                <p className="tn" style={{ margin: 0 }}>
                                    {loading ? '…' : fmt(stats?.[t.key])}
                                </p>
                                <p className="ts">{t.sub}</p>
                            </div>
                        ))}
                    </div>
                )}
                {!loading && !failed && (
                    <p className="pg-sub" style={{ margin: 0 }}>
                        Counts organizations created in each window, so the longer windows include the shorter ones.
                    </p>
                )}
            </div>
        </AreaShell>
    );
}
